import { ServerBaseEntity } from './ServerBaseEntity';
import { copyValues } from '@iris/common/utils/object.utils';
import { IrisFieldsTranslationSet } from '@iris/common/models/translations';

export interface IrisSelectedTagI {
  entityId: string;
  entityName: string;
  id: number;
  tagId: number;
}

export enum IrisTagType {
  Country = 'Country',
  Company = 'Company',
  Department = 'Department',
  ProjectWorkflow = 'ProjectWorkflow',
  FileType = 'FileType',
  FlagSymbols = 'FlagSymbols',
  Tag = 'Tag',
  Skill = 'Skill',
  QuickAccess = 'quick_access',
  Project = 'Project',
  DMS = 'DMS',
}

export interface IrisTagI extends ServerBaseEntityI {
  name: string;
  nameTranslated: string;
  type: IrisTagType;
  value: string;
  owner: number;
  projectId: number;
  color: string;
  isActive: boolean;
  isPrivate: boolean;
  translations: IrisFieldsTranslationSet;
  selected?: boolean;
  get public(): boolean;
  set public(value: boolean);
}

export class IrisTag extends ServerBaseEntity<IrisTag> implements IrisTagI {
  name: string = undefined;
  nameTranslated: string = undefined;
  type: IrisTagType = undefined;
  value: string = undefined;
  owner: number = undefined;
  projectId: number = undefined;
  color: string = undefined;
  isActive: boolean = undefined;
  isPrivate: boolean = undefined;
  translations: IrisFieldsTranslationSet = undefined;
  selected?: boolean = undefined;

  constructor(params?) {
    super(params);
    if (params) {
      copyValues(this, params);
    }
  }

  set public(value: boolean) {
    this.isPrivate = !value;
  }

  get public(): boolean {
    return !this.isPrivate;
  }
}
